let baseUrl: string;

switch (process.env.NODE_ENV) {
  case "development":
    // 开发环境url
    baseUrl = "/api";
    break;
  case "test":
    // 测试环境url
    baseUrl = "/api";
    break;
  case "production":
    // 生产环境url
    baseUrl = "/api";
    break;
  default:
    baseUrl = "";
}

export default baseUrl;
